export default __webpack_public_path__ + "static/media/logo.570ca80e.svg";